// eslint-disable-next-line import/prefer-default-export
export const getEventQueryLeftRight = (left, xMonthsFromToday = 6) => {
  const today = new Date();
  const tempDate = new Date(today.getTime());
  const rightDate = new Date(tempDate);
  rightDate.setMonth(today.getMonth() + xMonthsFromToday);
  const right = rightDate.toISOString();
  return { left, right };
};
